// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1zv6Y","list":"Menu_list__3V4CL","item":"Menu_item__1skiV"};